import { BenefitsCard } from "./WACardWrappers";

const TrustGallabox: React.FC = () => {
    return (
        <div className="py-10 max-w-6xl mx-auto">
            <h3 className="lg:text-4xl text-3xl font-semibold max-w-4xl mx-auto w-full text-center px-2 pb-10">
                Why <b className="text-blue-500">1500+ Customers</b> Trust Gallabox?
            </h3>
            <div className="lg:text-lg text-base mb-10 text-center mx-auto" style={{ maxWidth: "900px" }}>
                Gallabox is a potent tool to generate WhatsApp QR codes and an essential platform to boost your WhatsApp Automation requirements. Below are five compelling reasons
                why you should consider Gallabox for all your WhatsApp Automation needs:
            </div>
            <div className="max-w-6xl w-full mx-auto flex flex-col gap-6">
                <div className="flex gap-3 flex-col lg:flex-row px-5 md:px-10 lg:px-0 pt-10 lg:space-y-0 space-y-10">
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                alt="Supercharge Your Sales Pipeline"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon1.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl  m-0">Supercharge Your Sales Pipeline</h3>
                            <p className="p-3 text-left text-gray-500 text-center">
                                Send personalised recommendations to your potential customers based on their behaviour, purchase history, and more.
                            </p>
                        </div>
                    </BenefitsCard>
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                alt="Streamline Your Process Efficiency"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon2.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Streamline Your Process Efficiency</h3>
                            <p className="p-3 text-left text-gray-500 text-center">
                                As our bots handle routine tasks, your team gets more time to focus on larger, strategic initiatives that need a human touch.
                            </p>
                        </div>
                    </BenefitsCard>

                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                alt="Implement Savvy Marketing Tactics"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon3.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Implement Savvy Marketing Tactics</h3>
                            <p className="p-3 text-left text-gray-500 text-center">
                                Establish a custom WhatsApp drip campaign to reach your dream 100 customers just when they least anticipate it.
                            </p>
                        </div>
                    </BenefitsCard>
                </div>
                <div className="flex gap-3 flex-col lg:flex-row px-5 md:px-10 lg:px-0 pt-10 lg:space-y-0 space-y-10">
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                alt="Enhance Every Customer Interaction"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon4.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Enhance Every Customer Interaction</h3>
                            <p className="p-4 text-left text-gray-500 text-center">
                                Keep your contacts engaged by dispatching timely updates, reminders and even a dash of amusing GIFs for good measure
                            </p>
                        </div>
                    </BenefitsCard>
                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                alt="Establish a Single Source of Truth"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon5.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Establish a Single Source of Truth</h3>
                            <p className="p-4 text-left text-gray-500 text-center">
                                Maintain clear communication channels by storing all conversations neatly collated in a single location, ensuring nothing is overlooked.
                            </p>
                        </div>
                    </BenefitsCard>

                    <BenefitsCard>
                        <div style={{ position: "relative" }}>
                            <img
                                alt="Amplify Your Profits and Revenue"
                                className=" h-24 w-24"
                                src="https://assets.gallabox.com/gb-home/whatsapp-link-gen/icon6.png"
                                style={{ position: "absolute", top: "-5rem", right: "6rem" }}
                            />
                            <h3 className="text-2xl m-0">Amplify Your Profits and Revenue</h3>
                            <p className="p-3 text-left text-gray-500 text-center">
                                Construct and execute tailored Facebook and Instagram advertisements that guide leads directly to WhatsApp, consequently reducing your cost per
                                lead.
                            </p>
                        </div>
                    </BenefitsCard>
                </div>
            </div>
        </div>
    );
};

export default TrustGallabox;
